import { useRef } from 'react';
/** Returns a click handler that calls `onTrigger` after `count` taps in quick succession. */
export const useRepeatedTap = ({ count, onTrigger, maxGapMs = 1000 }) => {
    const taps = useRef({ count: 0, lastTapAt: 0 });
    return () => {
        const now = Date.now();
        const isContinuation = now - taps.current.lastTapAt <= maxGapMs;
        taps.current = { count: isContinuation ? taps.current.count + 1 : 1, lastTapAt: now };
        if (taps.current.count >= count) {
            taps.current = { count: 0, lastTapAt: 0 };
            onTrigger();
        }
    };
};
